import { BehaviorSubject, } from 'rxjs';
import { Injectable } from '@angular/core';
import { ReferralInfoApiService } from '../../service/referral-info-api.service';
import { DefendantInfo } from 'src/app/core/models/models';

@Injectable({ providedIn: 'root' })
export class CivilInfoReferralState {

  private dataSource = new BehaviorSubject<DefendantInfo | null>(null);
  private caseSequenceNumber = '';
  data$ = this.dataSource.asObservable();

  constructor(private referralApiService: ReferralInfoApiService) { }

  loadData(): void {
    this.referralApiService.getCivilDefendantInfo(+this.caseSequenceNumber).subscribe(data => {
      this.dataSource.next(data);
    });
  }

  setParameters(caseSequenceNumber: string) {
    this.caseSequenceNumber = caseSequenceNumber;
  }

  checkReferralStatus(sequenceNumber: string) {
    return this.referralApiService.checkCaseReferralStatus(sequenceNumber);
  }
}
